import React from 'react';
import Modal from 'src/ConnectedComponents/utils/Modal';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import { Paragraph, FlexBox } from 'src/lib/StyledComponents';

let RemoveFundraiserModal = ({ removeOnly, removeAndUnassign, onClose, fundraiser, ...props }) => (
	<Modal title={`Remove from the team: ${fundraiser.name}`} onClose={onClose}>
		<form>
			<Paragraph marginTop="0px">
				{`You are about to remove ${fundraiser.name} from your team.`}
			</Paragraph>
			<Paragraph>
				{`Please select if you want to also unassign all the donors currently in ${fundraiser.first}'s portfolio. (${fundraiser.portfolio_count} donor(s))`}
			</Paragraph>
			<FlexBox justifyContent="space-between" alignItems="center">
				<RoundedRectangleButton
					padding="6px 10px 4px"
					fontWeight="700"
					display="flex"
					onClick={removeOnly}
					disabled={false}
					disabledBackgroundColor="#D4D7E4"
					{...props}
				>
					Remove only
				</RoundedRectangleButton>
				<RoundedRectangleButton
					padding="6px 10px 4px"
					fontWeight="700"
					display="flex"
					onClick={removeAndUnassign}
					disabled={false}
					disabledBackgroundColor="#D4D7E4"
					{...props}
				>
					Remove and Unassign
				</RoundedRectangleButton>
			</FlexBox>
		</form>
	</Modal>
);

export default RemoveFundraiserModal;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/RemoveFundraiserModal/index.js